angular.module('admin.reindexing.index', [
    'services.utility',
    'services.algoliaResource',
    'services.localizedMessages',
  ]);
  
  angular.module('admin.reindexing.index').config(["$stateProvider", function($stateProvider) {
    $stateProvider
      .state('admin.reindexing', {
        url: '/reindexing',
        title: 'Algolia Reindexing',
        templateUrl: './reindexing.tpl.html'
      });
  }]);
  
  angular.module('admin.reindexing.index').controller('ReindexingIndexCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'reindexing',
    function($scope, localizedMessages, algoliaResource){
        $scope.localizedMessages = localizedMessages;
        $scope.algoliaArticlesReindexing = function() {
            algoliaResource.indexingArticles().then((result) =>{
                $scope.algoliaSuccess = true;
            }).catch((error) => {
                $scope.algoliaError = true;
            })
        }
        $scope.algoliaAuthorReindexing = function() {
            algoliaResource.indexingAuthors().then((result) =>{
                $scope.algoliaSuccess = true;
            }).catch((error) => {
                $scope.algoliaError = true;
            })
        }
        $scope.algoliaTagsReindexing = function() {
            algoliaResource.indexingTags().then((result) =>{
                $scope.algoliaSuccess = true;
            }).catch((error) => {
                $scope.algoliaError = true;
            })
        }
      
    }
  ]);
  


// WEBPACK FOOTER //
// ./client/src/app/admin/reindexing/reindexing.js